import Character from "../../character/Character";
import GridTile from "../../grid/GridTile";
import PathPlan from "./PathPlan";

export default class PathPlanFallDown extends PathPlan {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     */
    constructor(startTile, endTile, pathSteps) {
        super(startTile, endTile, pathSteps);
    }

    /**
     * @override
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {
        /////////////////////////////////////////////
        // Fall down 
        /////////////////////////////////////////////

        const result = this.fallDown(character, frameTimeRatio, this.endTile);

        if (result) {
            this.assertEndTileReached(character, this.endTile);
        }

        return result;
    }

    /**
     * @override
     * @return {boolean} True if this plan requires that the character be standing on top of a solid tile when it starts.
     */
    isSolidFloorRequiredAtStart() {
        return false;
    }

    
    /**
     * @returns {String}
     */
    toString() {
        return 'FallDown(' + this.pathSteps + ')';
    }
}